import { render, staticRenderFns } from "./FaqEditor.vue?vue&type=template&id=7bc93288&scoped=true&"
import script from "./FaqEditor.vue?vue&type=script&lang=js&"
export * from "./FaqEditor.vue?vue&type=script&lang=js&"
import style0 from "./FaqEditor.vue?vue&type=style&index=0&id=7bc93288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc93288",
  null
  
)

export default component.exports